import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Drawer from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/Drawer';
import ContentPicker from './ContentPicker';

const styles = () => ({
  root: {},
  content: {},
});

const ManageLineItemModal = ({
  className,
  classes,
  lineItemResource,
  isModalOpen,
  onClose,
}) => {
  return (
    <Drawer
      className={classNames(classes.root, className)}
      open={isModalOpen}
      onClose={onClose}
    >
      <ContentPicker
        className={classes.content}
        lineItemResource={lineItemResource}
      />
    </Drawer>
  );
};

ManageLineItemModal.defaultProps = {
  className: '',
};

ManageLineItemModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(ManageLineItemModal);
